export class LoyaltyShopCategory {
    ID = 0;
    Wholesaler = 0;
    SortOrder = 0;
    Active = true;
    Description = '';
}
